import React from 'react';
import { Helmet } from 'react-helmet';

// Global Components
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import PageTitleAndFilters from 'components/PageTitleAndFilters';
import PageTitleAndFiltersPusher from 'components/PageTitleAndFiltersPusher';
import RoleGate from 'components/RoleGate';
import RoleButton from 'components/RoleButton';
import SaveMessage from 'components/SaveMessage';

import { ADMIN } from 'components/RoleGate/constants';
import {
    COMMODITY_CREATE_NAMESPACE,
    COMMODITY_DELETE_NAMESPACE,
    COMMODITY_UPDATE_NAMESPACE
} from 'services/commodities/constants';
import {
    CREATE_MODAL_QUERY_STRING_PARAM,
    DELETE_MODAL_QUERY_STRING_PARAM
} from 'components/VirtualizedTable/constants';
import HarvestSchemaExistsGate from 'components/HarvestSchemaExistsGate';
import SingleActiveTableRowGate from 'components/SingleActiveTableRowGate';
import ButtonIconWrapper from 'components/ButtonIconWrapper';
import { MdDelete } from 'react-icons/md';

// Local Components
import CommoditiesVirtualizedTable from './components/CommoditiesVirtualizedTable';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

export default function Commodities(): React.ReactElement {
    return (
        <HarvestSchemaExistsGate>
            <RoleGate requiredRoles={[ADMIN]}>
                <ErrorBoundary
                    namespace="Commodities"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <Helmet>
                        <title>Commodities - {REACT_APP_PROJECT_NAME}</title>
                    </Helmet>
                    <PageTitleAndFilters
                        title="Commodities"
                        searchInputPlaceholder="Search"
                        hideFilters
                        MessageComponent={
                            <SaveMessage
                                namespace={[
                                    COMMODITY_CREATE_NAMESPACE,
                                    COMMODITY_UPDATE_NAMESPACE,
                                    COMMODITY_DELETE_NAMESPACE
                                ]}
                            />
                        }
                        FirstActionButton={
                            <SingleActiveTableRowGate>
                                <RoleButton
                                    requiredRoles={[ADMIN]}
                                    params={{
                                        [DELETE_MODAL_QUERY_STRING_PARAM]: true
                                    }}
                                    buttonProps={{
                                        icon: true,
                                        color: 'black',
                                        basic: true,
                                        style: {
                                            marginRight: 0,
                                            marginLeft: 8
                                        }
                                    }}
                                >
                                    <ButtonIconWrapper>
                                        <MdDelete
                                            style={{
                                                fontSize: 20
                                            }}
                                        />
                                    </ButtonIconWrapper>
                                    Delete
                                </RoleButton>
                            </SingleActiveTableRowGate>
                        }
                        SecondActionButton={
                            <RoleButton
                                requiredRoles={[ADMIN]}
                                params={{
                                    [CREATE_MODAL_QUERY_STRING_PARAM]: true
                                }}
                                ignoreSeason
                                buttonProps={{
                                    secondary: true,
                                    style: {
                                        marginRight: 0,
                                        marginLeft: 8
                                    }
                                }}
                            >
                                Create New
                            </RoleButton>
                        }
                    />
                    <PageTitleAndFiltersPusher>
                        <CommoditiesVirtualizedTable tableId="commodities" />
                    </PageTitleAndFiltersPusher>
                </ErrorBoundary>
            </RoleGate>
        </HarvestSchemaExistsGate>
    );
}
